/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';

export default createContext({
  token: localStorage.getItem('session'),
  setToken: (token: string | null) => {},
});
